/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react"
import { Box, Button, TextField, Typography, CircularProgress } from "@mui/material"
import { useParams } from "react-router-dom"
import dayjs from "dayjs"
import { getDocs, collection, query, where, QuerySnapshot } from "firebase/firestore"
import { db } from "../firebase"


const SearchIndividual = () => {
  const urlParams = useParams<{ individualNo: string }>()
  const [individualNo, setIndividualNo] = useState<string>('')
  const [individualInfo, setIndividualInfo] = useState<any>()
  const [errorMessage, setErrorMessage] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)

  useEffect(() => {
    const no = urlParams.individualNo
    if (!no) return
    setIndividualNo(no)
    search(no)
  }, [urlParams])

  const search = (individualNo: string) => {
    setErrorMessage('')
    setIndividualInfo(undefined)
    setLoading(true)
    getDocs(query(collection(db, 'individuals'), where('individualNo', '==', individualNo))).then((_: QuerySnapshot) => {
      const [doc] = _.docs
      doc ? setIndividualInfo(doc.data()) : setErrorMessage('該当する個体情報がありません')
    }).finally(() => {
      setLoading(false)
    })
  }

  const onChange = ({ target: { value } }: any) => {
    setIndividualNo(value)
  }

  return (
    <Box display="contents" justifyItems="center">
      <Box display="flex" justifyContent="center" mt={2}>
        <Typography variant="h4">個体情報検索</Typography>
      </Box>
      <Box display="flex" justifyContent="center" alignContent="center" mt={2}>
        <TextField
          type="number"
          id="individualNo"
          name="individualNo"
          onChange={onChange}
          value={individualNo}
          inputProps={{
            inputMode: "numeric", pattern: "[0-9]*"
          }}
          sx={{ width: 200 }}
        />
      </Box>
      <Box display="flex-col" m={1} justifyItems="center">
        <Box display="flex" justifyContent="center">
          <Typography variant="subtitle2" color="red">{errorMessage}</Typography>
        </Box>
        <Box display="flex" justifyContent="center" mt={2}>
          <Button variant="contained" onClick={() => search(individualNo)} disabled={loading}>検索</Button>
        </Box>
        {loading && (
          <Box display="flex" justifyContent="center" mt={2}>
            <CircularProgress />
          </Box>
        )}
      </Box>
      {
        individualInfo &&
        <Box display="flex" justifyContent="center">
          <Box component="form" sx={{ '& .MuiTextField-root': { m:1}}}>
            <div>
              <TextField label="個体識別番号" value={individualNo} sx={{ m: 1, width: '25ch' }} inputProps={{ readOnly: true }}/>
              <TextField label="捕獲者氏名" value={individualInfo.name} sx={{ m: 1, width: '25ch' }} inputProps={{ readOnly: true }}/>
            </div>
            <div>
              <TextField label="捕獲地" value={individualInfo.captureLocation} sx={{ m: 1, width: '25ch' }} inputProps={{ readOnly: true }}/>
              <TextField label="捕獲年月日" value={dayjs(individualInfo.captureDatetime).format('YYYY/MM/DD')} sx={{ m: 1, width: '25ch' }} inputProps={{ readOnly: true }}/>
            </div>
            <div>
              <TextField label="捕獲方法" value={individualInfo.captureMethod} sx={{ m: 1, width: '25ch' }} inputProps={{ readOnly: true }}/>
              <TextField label="月齢 (推定)" value={individualInfo.age} sx={{ m: 1, width: '25ch' }} inputProps={{ readOnly: true }}/>
            </div>
            <div>
              <TextField label="性別" value={individualInfo.sex} sx={{ m: 1, width: '25ch' }} inputProps={{ readOnly: true }}/>
              <TextField label="体重" value={`${individualInfo.weight}kg`} sx={{ m: 1, width: '25ch' }} inputProps={{ readOnly: true }}/>
            </div>
            <div>
              <TextField label="解体年月日" value={dayjs(individualInfo.demolitionDate).format('YYYY/MM/DD')} sx={{ m: 1, width: '25ch' }} inputProps={{ readOnly: true }}/>
              <TextField label="加工施設所在地" value="北海道歌志内市歌神36" sx={{ m: 1, width: '25ch' }} inputProps={{ readOnly: true }}/>
            </div>
            <div>
                <TextField label="加工年月日" value={dayjs(individualInfo.processingDate).format('YYYY/MM/DD')} sx={{ m: 1, width: '25ch' }} inputProps={{ readOnly: true }}/>
              <TextField label="加工施設責任者" value="田中　一紀" sx={{ m: 1, width: '25ch' }} inputProps={{ readOnly: true }}/>
            </div>
          </Box>
          </Box>

      }
        <Box display="flex-col" justifyContent="center" mt={2}>
          <Typography className="text-center">りんどう</Typography>
          <Typography className="text-center">北海道歌志内市字歌神３６</Typography>
          <Typography className="text-center">0125−35−9107</Typography>
        </Box>
    </Box>
  )
}

export default SearchIndividual
